import { render, staticRenderFns } from "./MultipleShiftDeleteDialog.vue?vue&type=template&id=5ab20b14&"
import script from "./MultipleShiftDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./MultipleShiftDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports